<template>
  <!--
  ==========================================================================
  General
  ==========================================================================
  -->
  <form class="h-100 scrollable padded">
    <string-form-field
      :label="$t('file.fields.customer')"
      disabled
      :value="value.request.customer.companyName"
    />

    <string-form-field
      :label="$t('file.fields.status')"
      disabled
      :value="value.status.label"
    />

    <string-form-field
      :label="$t('file.fields.network')"
      disabled
      :value="value.request.network.companyName"
    />

    <string-form-field
      :label="$t('file.fields.provider')"
      disabled
      :value="value.product.provider.companyName"
    />

    <string-form-field
      :label="$t('file.fields.product')"
      disabled
      :value="value.product.name"
    />

    <string-form-field
      :label="$t('file.fields.productDescription')"
      disabled
      multiline
      :value="value.product.description"
    />
  </form>
</template>
<script>
import EditorMixin from "vue-template/common/mixins/EditorMixin";
import ErrorCounterMixin from "vue-forms/mixins/ErrorCounterMixin";

export default {
  mixins: [EditorMixin, ErrorCounterMixin]
};
</script>
